// extracted by mini-css-extract-plugin
export default {"today":"DateSubheader_today__5SFTP"};